import intl from 'react-intl-universal';
import { tailwindOverride, Tooltip } from '@getsynapse/design-system';

interface TaskTemplateTimelineCellProps {
  startDay?: string;
  duration?: string;
}

const TaskTemplateTimelineCell = ({
  startDay,
  duration,
}: TaskTemplateTimelineCellProps) => {
  if (!startDay || !duration) {
    return <span>-</span>;
  }

  const off = Math.max(0, +startDay || 0);
  const dur = Math.max(1, +duration || 1);
  const start = off + 1;
  const end = start + dur - 1;
  const dayLabel = intl.get(
    'SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUILD_SECTION.TIMELINE.DAY_LABEL'
  );
  const durationUnit = intl.get(
    'SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUILD_SECTION.TIMELINE.DURATION_UNIT'
  );

  return (
    <Tooltip
      trigger={
        <div className='flex items-center gap-x-2'>
          <span>{`${dayLabel} ${start} - ${dayLabel} ${end}`}</span>
          <span
            className={tailwindOverride(
              'bg-neutral-lighter-two rounded-full',
              'font-semibold text-neutral-darker',
              'py-0.5 px-2 text-xs whitespace-nowrap'
            )}
          >
            {`${dur}${durationUnit}`}
          </span>
        </div>
      }
      openMode='hover2'
      timeout={0}
      usePortal
      showPopper
    >
      {intl.get(
        'SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUILD_SECTION.TIMELINE.TIME_LINE_CELL_TOOLTIP',
        { dur, off }
      )}
    </Tooltip>
  );
};

export default TaskTemplateTimelineCell;
